import React from 'react';
import PropTypes from 'prop-types';

const CommunityCatalogImage = props => {
	if (props.imageUrl && props.imageUrl.length > 0) {
		return (
			<div>
				<img
					id="community-catalog-image"
					title={props.catalogName}
					alt={props.catalogName}
					src={props.imageUrl}
				/>
			</div>
		);
	} else {
		return (
			<div className="catalog-no-image">
				<div
					className="icon-list-number iconSVG_Darker_NoHover"
					title={props.catalogName}
				/>
			</div>
		);
	}
};

CommunityCatalogImage.propTypes = {
	imageUrl: PropTypes.string,
	userName: PropTypes.string,
	catalogName: PropTypes.string,
};

export { CommunityCatalogImage };
